import "./socials.css";
import { WrapperComponent, SectionTitle, CircularBtn, SocialBtn } from "../../_imports";
import QrGrupoWhats from "../../../assets/imgs/qrs/grupo_whatsapp.png";
import Links from "../../../constants/links";
import { faInstagram, faLinkedin, faFacebook, faXTwitter, faThreads, faTiktok } from "@fortawesome/free-brands-svg-icons";

function Socials() {
    return (
        <section className="socials-section">
            <WrapperComponent>
                <SectionTitle text="ACOMPANHE AS NOVIDADES" color="green" />
                <div className="socials-container">
                    <div className="socials-content">
                        <p className="socials-desc">
                            Siga a Tonalida e impulsione sua carreira! Receba dicas semanais de entrevistas e conteúdos exclusivos para conquistar seu novo emprego.
                        </p>
                        <div className="social-links-column">
                            <SocialBtn
                                link={Links.x}
                                handle="@TonalidaAPP"
                                icon={faXTwitter}
                                variant="twitter"
                            />
                            <SocialBtn
                                link={Links.tiktok}
                                handle="@tonalida_app"
                                icon={faTiktok}
                                variant="tiktok"
                            />

                            <SocialBtn
                                link={Links.threds}
                                handle="@tonalida_app"
                                icon={faThreads}
                                variant="threads"
                            />
                            <SocialBtn
                                link={Links.instagram}
                                handle="@tonalida_app"
                                icon={faInstagram}
                                variant="instagram"
                            />
                            <SocialBtn
                                link={Links.linkding}
                                handle="Tonalida"
                                icon={faLinkedin}
                                variant="linkedin"
                            />
                            <SocialBtn
                                link={Links.facebook}
                                handle="Tonalida"
                                icon={faFacebook}
                                variant="facebook"
                            />
                            {/* <SocialBtn
                                link={Links.youtube}
                                handle="@tonalida_app"
                                icon={faYoutube}
                                variant="youtube"
                            /> */}
                        </div>
                    </div>

                    <div className="whatsapp-group-card">
                        <h3 className="whatsapp-title">Grupo VIP de Vagas</h3>
                        <p className="whatsapp-desc">Receba vagas em primeira mão no seu WhatsApp!</p>
                        <div className="qr-code-placeholder">
                            <img src={QrGrupoWhats} alt="QR Code para entrar no grupo do WhatsApp" />
                        </div>
                        <CircularBtn
                            text="Entrar no Grupo"
                            link={Links.whatsappGrupo}
                            variant="company"
                            className="whatsapp-btn-circular"
                        />
                    </div>
                </div>
            </WrapperComponent>
        </section>
    );
}

export default Socials;
